import { useMemo } from 'react';
import { AppHeader, Fraction, ProgressBar } from '../components/common';
import { CATEGORIES } from '../data/categories';
import { useT } from '../hooks/useT';
import { computeStats } from '../services/progress';
import { useBank } from '../state/BankContext';
import { useProgress } from '../state/ProgressContext';
import { useRouter } from '../state/RouterContext';
import { useSettings } from '../state/SettingsContext';

export function CategoriesScreen() {
  const t = useT();
  const { navigate } = useRouter();
  const { uiLang } = useSettings();
  const { questions, signs } = useBank();
  const { progress } = useProgress();

  const stats = useMemo(() => computeStats(progress, questions, signs), [progress, questions, signs]);

  return (
    <>
      <AppHeader title={t('byTopic')} />
      <main id="main" className="app-main stack">
        {CATEGORIES.map((category) => {
          const stat = stats.categories.find((c) => c.id === category.id);
          const total = stat?.total ?? 0;
          const learned = stat?.learned ?? 0;
          const needs = stat?.needsPractice ?? 0;

          return (
            <button
              key={category.id}
              type="button"
              className="tile"
              disabled={total === 0}
              onClick={() => navigate({ name: 'quiz', mode: 'category', categoryId: category.id })}
              style={{ flexDirection: 'column', alignItems: 'stretch', gap: 'var(--space-3)' }}
            >
              <span className="row" style={{ width: '100%' }}>
                <span className="tile__icon" aria-hidden="true">
                  {category.icon}
                </span>
                <span className="tile__label">
                  {uiLang === 'ar' ? category.nameAr : category.nameEn}
                  <span className="tile__sub">
                    <Fraction value={learned} max={total} /> {t('learnedLabel')}
                  </span>
                </span>
                {needs > 0 ? <span className="badge badge--practice">⭐ {needs}</span> : null}
                <span className="tile__chev" aria-hidden="true">
                  ›
                </span>
              </span>
              <ProgressBar value={learned} max={Math.max(total, 1)} tone="success" />
            </button>
          );
        })}
      </main>
    </>
  );
}
